<section class="share-survey-access-dialog">
    <div class="share-survey-dialog-header uscb-layout-row uscb-bg-primary uscb-color-white">
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8 share-survey-dialog-title">{{shareSurveyAccessDialogData?.title || 'Share Survey Access'}}</span>
        <span class="vcenter share-survey-dialog-close">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>
    <mat-dialog-content>
        <div class="my-dialog-content uscb-layout-column">
            <div>Those you share with can:</div>
            <ul class="indent-txt share-survey-bullet-list bottom-padding-sm">
                <li>View and overwrite survey data</li>
                <li>Submit the survey</li>
                <li>Request extensions</li>
                <li>Share with others</li>
                <li>Remove others (including you) from those that have been shared with</li>
            </ul>
            <div>
                @if (isConfirmRequest()) {
                <span class="md-subhead sm-padding-r">CONFIRM EMAIL ADDRESS </span>
                }
                @if (isDelegationSuccess()) {
                <span class="md-subhead sm-padding-r">THANK YOU</span>
                }
                @if (!(isConfirmRequest() || isDelegationSuccess() || isSendingRequest())) {
                <ng-container>
                    <span class="md-subhead">
                        ENTER EMAIL ADDRESS OF DELEGATE
                    </span>
                    &nbsp;<span class="red-text"><b>*</b></span>
                    <span class="grey">
                        (Step 1 of 2)
                    </span>
                </ng-container>
                }
                @if (isConfirmRequest()) {
                <span class="grey">
                    (Step 2 of 2)
                </span>
                }
            </div>
            @if (!(isDelegationSuccess() || isSendingRequest())) {
            <form [formGroup]="formGroup" class="uscb-form">
                @if (!isConfirmRequest()) {
                <div>
                    <div class="uscb-layout-column uscb-layout-align-start-stetch">

                        @for (item of currentDelegates(); track item.id; let index = $index) {
                        <ng-container>
                            <div class="share-survey-email-row uscb-flex-row uscb-layout-row uscb-layout-align-start-center">
                                <input class="uscb-flex share-survey-email-input" formControlName="{{item.id}}" [(ngModel)]="item.email" name="{{item.id}}"
                                    aria-label="delegate email" type="email" [placeholder]="placeholder" (blur)="item.afterBlur = true" tabindex="0" />
                                <div class="share-survey-email-actions">
                                    @if (currentDelegates().length !== 1) {
                                    <button title="Remove Email" class="uscb-primary-button"
                                        (click)="removeInput(item.id)" (keyup.enter)="removeInput(item.id)" [ngClass]="{'last-delegate-input-btn' : currentDelegates().length === 50}" tabindex="0">
                                        <i class="fa fa-minus"></i>
                                    </button>
                                    }
                                    @if (index === currentDelegates().length - 1) {
                                    <button title="Add Additional Email"
                                        class="ecorr-button-add uscb-primary-button" (click)="addInput()" (keyup.enter)="addInput()" [disabled]="formGroup.invalid" tabindex="0">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                    }
                                </div>
                            </div>
                            <div class="uscb-flex-row uscb-margin-B-8">
                                @if (showError(item.id) && item.afterBlur && item.email.length > 0) {
                                <mat-error class="red-text-darker">Please enter a valid email
                                    address.</mat-error>
                                }
                            </div>
                        </ng-container>
                        }
                    </div>
                </div>
                }
                @if (!isConfirmRequest()) {
                <ng-container>
                    <div class="uscb-margin-T-10">
                        <span class="md-subhead sm-padding-r">ENTER NOTES TO DELEGATE(S)</span>
                        <span class="grey"> (optional)</span>
                    </div>
                    <div md-no-float class="md-block less-padded uscb-layout-column">
                        <div class="uscb-flex-row uscb-layout-row">
                            <textarea class="uscb-flex-row-100 ta-pad" formControlName="note" name="note" aria-label="notes to delegates (optional)" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" tabindex="0"></textarea>
                        </div>
                    </div>
                </ng-container>
                }
                @if (isConfirmRequest()) {
                <ng-container>
                    <span class="bottom-padding-md">Please verify the email address below will
                        be given access to a survey. If this is correct, select the Confirm button below.</span>
                    <div class="center-text">
                        <br>
                        @for (delegate of currentDelegates(); track delegate.id) {
                        <ng-container>
                            <div class="md-title uscb-margin-T-4">{{delegate.email}}</div>
                        </ng-container>
                        }
                    </div>
                    <div class="center-text top-padding"><i>{{formGroup.get('note').value}}</i></div>
                </ng-container>
                }
            </form>
            }
            @if (isDelegationSuccess()) {
            <div class="margin-lr uscb-margin-T-4 uscb-margin-B-4 uscb-text-align-center">
                A delegation request has been sent to
                @for (newEmail of currentNewEmails(); track newEmail; let index = $index) {
                <div class="uscb-margin-T-4">{{newEmail}}@if (index !== currentNewEmails().length - 1) {,}@if (index === currentNewEmails().length - 1) {.}
                </div>
                }
                You can monitor the status of delegation requests below.
            </div>
            }
            @if (currentDelegationError()) {
            <mat-error class="uscb-text-align-center uscb-margin-T-4 red-text-darker">Error: {{currentDelegationError()}}</mat-error>
            }
        </div>
        <mat-dialog-actions class="share-survey-actions uscb-layout-row-gt-md uscb-layout-column-md uscb-layout-column-sm uscb-layout-align-center-center">
            @if (!(isDelegationSuccess() || isSendingRequest())) {
            <ng-container>
                <button type="button" class="uscb-secondary-button uscb-margin-LR-10 ecorr-width-180px" (click)="cancel()" (keyup.enter)="cancel()" tabindex="0">
                    Cancel Request
                </button>
                @if (!isConfirmRequest()) {
                <button type="button" [disabled]="formGroup.invalid" (click)="isFormValid()" (keyup.enter)="isFormValid()" class="uscb-primary-button ecorr-width-180px" tabindex="0">
                    submit request
                </button>
                }
                @if (isConfirmRequest()) {
                <button type="button" class="uscb-primary-button ecorr-width-80px" (click)="edit()" (keyup.enter)="edit()" tabindex="0">
                    edit
                </button>
                <button type="button" class="uscb-primary-button ecorr-width-120px uscb-margin-LR-10" (click)="delegateSurvey()" (keyup.enter)="delegateSurvey()"
                    [disabled]="currentDelegationError() !== ''" tabindex="0">
                    confirm
                </button>
                }
            </ng-container>
            }
            @if (isDelegationSuccess()) {
            <ng-container>
                <button type="button" class="uscb-secondary-button ecorr-width-120px" (click)="cancel()" (keyup.enter)="cancel()" tabindex="0">
                    Close
                </button>
                <button type="button" class="uscb-primary-button ecorr-width-140px" (click)="addMore()" (keyup.enter)="addMore()" tabindex="0">
                    <i class="fa fa-plus"></i>
                    Add More
                </button>
            </ng-container>
            <div></div>
            @if (isSendingRequest()) {
            <button type="button" disabled class="uscb-primary-button ecorr-width-180px">
                PLEASE WAIT... &nbsp;&nbsp; <i class="fa fa-spinner fa-spin fa-lg"></i>
            </button>
            }
            }
        </mat-dialog-actions>
        <br>
        <app-linear-loading [loading]="isSendingRequest() || loadingDelegates()"></app-linear-loading>
        @if (!isNoDelegatees() || loadingDelegates()) {
        <div class="dialog-content-padding">
            @if (currentUpdateMessage()) {
            <div class="success-label dialog-content-padding uscb-text-align-center">
                {{currentUpdateMessage()}}
            </div>
            }
            <mat-tab-group class="primary-tabs share-survey-tabs uscb-flex" animationDuration="0ms" (selectedTabChange)="selectedTabChanged($event)">
                <mat-tab label="tab">
                    <ng-template mat-tab-label>
                        Current Delegates
                    </ng-template>
                    <div class="uscb-padding-4">
                        @if (loadingDelegates()) {
                        <div class="share-survey-delegates-loading uscb-text-align-center" role="status" aria-live="polite">
                            <i class="fa fa-spinner fa-spin fa-2x uscb-margin-B-8" aria-hidden="true"></i>
                            <div>Loading delegation status…</div>
                        </div>
                        }
                        @if (!loadingDelegates()) {
                        <div class="share-survey-table-scroll">
                        <table class="dialog-table share-survey-delegates-table uscb-width-100" tabindex="0">
                            <tr tabindex="0">
                                <th class="dialog-th ecorr-width-140px uscn-text-align-center"
                                    (click)="reorder('createdDate', activeRequests)" (keyup.enter)="reorder('createdDate', activeRequests)" [attr.aria-sort]="ariaSort('createdDate')" tabindex="0">Date
                                    <i class="fa" [ngClass]="fasClass('createdDate')"></i>
                                </th>
                                <th class="dialog-th uscb-text-align-center ecorr-width-min-200px"
                                    (click)="reorder('delegateeEmailAddress', activeRequests)" (keyup.enter)="reorder('delegateeEmailAddress', activeRequests)" [attr.aria-sort]="ariaSort('delegateeEmailAddress')" tabindex="0">
                                    Email
                                    <i class="fa" [ngClass]="fasClass('delegateeEmailAddress')"></i>
                                </th>
                                <th class="dialog-th ecorr-width-140px uscn-text-align-center" (click)="reorder('status', activeRequests)" (keyup.enter)="reorder('status', activeRequests)" [attr.aria-sort]="ariaSort('status')" tabindex="0">
                                    Status
                                    <i class="fa" [ngClass]="fasClass('status')"></i>
                                </th>
                                <th class="dialog-th ecorr-width-120px uscn-text-align-center">Options</th>
                            </tr>
                            @for (activeRequest of currentActiveRequests(); track activeRequest) {
                            <tr tabindex="0">
                                <td class="dialog-td uscb-text-align-center">
                                    {{activeRequest.createdDate | date:'MM/dd/yyyy'}}
                                </td>
                                <td class="dialog-td">{{activeRequest.delegateeEmailAddress}}</td>
                                <td class="dialog-td uscb-text-align-center">{{activeRequest.status}}</td>
                                <td class="dialog-td uscb-text-align-center ecorr-control-container">
                                    <section>
                                        @if (activeRequest.enableResend === 'Y' && activeRequest.status !== 'Accepted') {
                                        <button type="button" (click)="handleDelegation('resend', 'secure/delegates/requests', activeRequest)" (keyup.enter)="handleDelegation('resend', 'secure/delegates/requests', activeRequest)"
                                            title="Resend Request" [disabled]="isSendingRequest()" class="uscb-color-accent ecorr-share-button" tabindex="0">
                                            <i aria-label="Resend request" class="fa fa-repeat fa-2x"></i>
                                        </button>
                                        }
                                        @if ('Request Sent' === activeRequest.status) {
                                        <button type="button"
                                            (click)="handleDelegation('revoke', 'secure/delegates/requests', activeRequest)" (keyup.enter)="handleDelegation('revoke', 'secure/delegates/requests', activeRequest)"
                                            title="Remove User from Survey" [disabled]="isSendingRequest()"
                                            class="uscb-color-accent ecorr-share-button" tabindex="0">
                                            <i aria-label="Remove delegate" class="fa fa-trash fa-2x"></i>
                                        </button>
                                        }
                                    </section>
                                    @if ('Accepted' === activeRequest.status) {
                                    <button type="button"
                                        (click)="handleDelegation('remove', 'secure/delegates/relationships', activeRequest)" (keyup.enter)="handleDelegation('remove', 'secure/delegates/relationships', activeRequest)"
                                        title="Revoke User from Survey" [disabled]="isSendingRequest() || !isAllowRemoval()"
                                        class="uscb-color-accent ecorr-share-button" tabindex="0">
                                        <i aria-label="Revoke delegate" class="fa fa-trash fa-2x"></i>
                                    </button>
                                    }
                                </td>
                            </tr>
                            }
                        </table>
                        </div>
                    }
                    </div>
                </mat-tab>
                <mat-tab label="tab">
                    <ng-template mat-tab-label>
                        Removed Delegates
                    </ng-template>
                    <div class="uscb-padding-T-4">
                        @if (loadingDelegates()) {
                        <div class="share-survey-delegates-loading uscb-text-align-center" role="status" aria-live="polite">
                            <i class="fa fa-spinner fa-spin fa-2x uscb-margin-B-8" aria-hidden="true"></i>
                            <div>Loading delegation status…</div>
                        </div>
                        }
                        @if (!loadingDelegates() && currentInactiveRequests().length===0) {
                        <p class="md-text">There are no removed delegates at this time.</p>
                        }
                        @if (!loadingDelegates() && currentInactiveRequests().length) {
                        <div class="share-survey-table-scroll">
                        <table class="dialog-table share-survey-delegates-table share-survey-delegates-table--three-cols uscb-width-100" tabindex="0">
                            <tr tabindex="0">
                                <th class="dialog-th ecorr-width-140px uscb-text-align-center"
                                    (click)="reorder('createdDate', inactiveRequests)" (keyup.enter)="reorder('createdDate', inactiveRequests)" [attr.aria-sort]="ariaSort('createdDate')" tabindex="0">Date
                                    <i class="fa" [ngClass]="fasClass('createdDate')"></i>
                                </th>
                                <th class="dialog-th ecorr-width-min-200px uscb-text-align-center"
                                    (click)="reorder('delegateeEmailAddress', inactiveRequests)" (keyup.enter)="reorder('delegateeEmailAddress', inactiveRequests)" [attr.aria-sort]="ariaSort('delegateeEmailAddress')" tabindex="0">
                                    Email
                                    <i class="fa" [ngClass]="fasClass('delegateeEmailAddress')"></i>
                                </th>
                                <th class="dialog-th ecorr-width-140px uscb-text-align-center"
                                    (click)="reorder('status', inactiveRequests)" (keyup.enter)="reorder('status', inactiveRequests)" [attr.aria-sort]="ariaSort('status')" tabindex="0">Status
                                    <i class="fa" [ngClass]="fasClass('status')"></i>
                                </th>
                            </tr>
                            @for (inactiveRequest of currentInactiveRequests(); track inactiveRequest) {
                            <tr tabindex="0">
                                <td class="dialog-td uscb-text-align-center">{{inactiveRequest.createdDate | date:'MM/dd/yyyy'}}</td>
                                <td class="dialog-td">{{inactiveRequest.delegateeEmailAddress}}</td>
                                <td class="dialog-td uscb-text-align-center">{{inactiveRequest.status}}</td>
                            </tr>
                            }
                        </table>
                        </div>
                        }
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
        }
    </mat-dialog-content>
</section>
